import { render, staticRenderFns } from "./tpl-12.vue?vue&type=template&id=1a867aba&scoped=true"
import script from "./tpl-12.vue?vue&type=script&lang=js"
export * from "./tpl-12.vue?vue&type=script&lang=js"
import style0 from "./tpl-12.vue?vue&type=style&index=0&id=1a867aba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a867aba",
  null
  
)

export default component.exports